module.exports = __webpack_public_path__ + "static/media/sitemap.34f83553.svg";